import * as types from "../actionTypes";
import AppHelper from "../../helpers/appHelper";
import {
  CUSTOMER_PROFILES_ENDPOINT,
  ALERT_Registrations_ENDPOINT,
  ALERT_TYPES_ENDPOINT
} from "../../helpers/apiUrls";
import ActionCreator, { pingEventService } from "../../helpers/apiRequestor";
import axios from "axios";
import {
  HttpType
} from "../../helpers/constantValues";

axios.defaults.headers['Pragma'] = 'no-cache'

export const accountAlerts = (isSilent = false) => {
  
  return (dispatch) => dispatch(ActionCreator(
    {
      url: AppHelper.getMiddlewareApiUrl(CUSTOMER_PROFILES_ENDPOINT),
      method: HttpType.GET,
      headers: {
        ...AppHelper.getSessionTokenHeaders(),
 
      }
    },
    isSilent ? '' :  types.GET_ACCOUNT_ALERTS_PENDING,
    types.GET_ACCOUNT_ALERTS_FULFILLED,
    types.GET_ACCOUNT_ALERTS_FAILED
  ));
};

export const removeAllAccountRegistrations = (registrationIds, accountno) => (dispatch) => {
  const promises = registrationIds.map(id => {

     pingEventService();
    dispatch({
      type: types.ACCOUNT_ALERT_UPDATE_PENDING,
    });
    return axios.delete(AppHelper.getApiUrl(ALERT_Registrations_ENDPOINT + `/${id}`), {
      headers: {
        ...AppHelper.getSessionTokenHeaders()
      }
    })
  })
  Promise.all(promises).then((responses) => {
    dispatch({
      type: types.ACCOUNT_ALERT_UPDATE_FULFILLED,
    });
    dispatch(getAccountAlertRegistrations(accountno, true))
      .catch(() => {
        dispatch({
          type: types.ACCOUNT_ALERT_UPDATE_ERROR,
        });
      })
  })
}
export const removeAlertRegistration = data => dispatch => {
  dispatch({
    type: types.ACCOUNT_ALERT_UPDATE_PENDING,
  });
  pingEventService();
  return axios
    .delete(AppHelper.getApiUrl(ALERT_Registrations_ENDPOINT + `/${data.deliveryAddress}`), {

      headers: {
        ...AppHelper.getSessionTokenHeaders()
      }
    })
    .then(response => {
      dispatch({
        type: types.ACCOUNT_ALERT_UPDATE_FULFILLED,
      });
      dispatch({
        type: types.REMOVE_ALERT_REGISTRATION,
        payload: data
      })
      dispatch(getAccountAlertRegistrations(data.accountNumber, true))
    })
    .catch(() => {
      dispatch({
        type: types.ACCOUNT_ALERT_UPDATE_ERROR,
      });
    })
};
export const addAlertRegistration = data => dispatch => {

  pingEventService();
  dispatch({
    type: types.ACCOUNT_ALERT_UPDATE_PENDING,
  });
  return axios
    .post(AppHelper.getApiUrl(ALERT_Registrations_ENDPOINT), data, {
      headers: {
        ...AppHelper.getSessionTokenHeaders()
      }
    })
    .then(response => {
      dispatch({
        type: types.ACCOUNT_ALERT_UPDATE_FULFILLED,
      });
      dispatch({
        type: types.ADD_ALERT_REGISTRATION,
        payload: data
      })
      dispatch(getAccountAlertRegistrations(data.accountNumber, true))
    })
    .catch(() => {
      dispatch({
        type: types.ACCOUNT_ALERT_UPDATE_ERROR,
      });
    })
}
export const updateAlertCriteria = (alertCriteria, registrationIds) => (dispatch) => {
  const promises = registrationIds.map(id => {
    return axios.post(AppHelper.getApiUrl(ALERT_Registrations_ENDPOINT + `/${id}`), { alertCriteria: alertCriteria }, {
      headers: {
        ...AppHelper.getSessionTokenHeaders()
      }
    })
  })
  Promise.all(promises).then((responses) => {
    dispatch({
      type: types.UPDATE_ALERT_REGISTRATION,
      payload: {
        alertCriteria, registrationIds
      }
    })
  })
}

export const getAccountAlertTypes = (accountno, isSilent = false) => dispatch => {
  return axios
    .get(AppHelper.getApiUrl(ALERT_TYPES_ENDPOINT.replace('{number}', `${accountno}`)),
      { headers: { ...AppHelper.getSessionTokenHeaders() } }
    )
    .then(response => {
      dispatch({
        type: types.GET_ACCOUNT_ALERT_TYPES_FULFILLED,
        data: response.data,
        accountno: accountno
      });
    })
    .catch(() => {
      dispatch({
        type: types.GET_ACCOUNT_ALERT_TYPES_FAILED,
        accountno: accountno
      });
    });
}
export const getAccountAlertRegistrations = (accountno, isSilent = false) => dispatch => {
  pingEventService();
  if (!isSilent) {
    dispatch({
      type: types.GET_ACCOUNT_ALERTS_PREFERENCES_PENDING,
      accountno: accountno
    });
  }
  return axios
    .get(AppHelper.getApiUrl(ALERT_Registrations_ENDPOINT + `?accountNumber=${accountno}`),
      { headers: { ...AppHelper.getSessionTokenHeaders() } }
    )
    .then(response => {
      dispatch({
        type: types.GET_ACCOUNT_ALERTS_PREFERENCES_FULFILLED,
        data: response.data,
        accountno: accountno
      });
    })
    .catch(() => {
      dispatch({
        type: types.GET_ACCOUNT_ALERTS_PREFERENCES_FAILED,
        accountno: accountno
      });
    });
};

